import React, { useState, useRef } from "react";
import { BsFilter } from "react-icons/bs";
import { IoIosSearch } from "react-icons/io";

const FilterBox = ({
  allQuery,
  handleFilterChange,
  activeFilter,
  setActiveFilter,
  resetFilterBtn,
  setLoading,
  activeButton,
  clickedLink,
  setActiveButton,
  fetchLectures,
}) => {
  const [contentHeight, setContentHeight] = useState(); // Track height state
  const contentRef = useRef(null); // Reference for content

  // Dynamically update height when activeFilter changes
  const toggleFilter = () => {
    if (activeFilter) {
      const height = contentRef.current.scrollHeight; // Get actual content height
      setContentHeight(height); // Set height for animation
    } else {
      setContentHeight(0); // Collapse the content
    }
  };

  // Trigger the height change whenever activeFilter changes
  React.useEffect(() => {
    toggleFilter();
  }, [activeFilter]);

  return (
    <div className="shadow-md z-10 rounded-md p-2 mb-4 bg-white lg:sticky md:sticky top-0 w-full">
      <div className="flex flex-wrap justify-between items-center gap-4 p-2 md:flex-nowrap">
        {/* Left Button Section */}
        <div className="rounded-md flex items-center gap-2 p-1 bg-[#FAF5FF] font-semibold w-fit md:w-auto sm:w-full">
          {[{ all: "All" }, { upComing: "Up Coming" }, { today: "Today" }].map(
            (item) => {
              // Extracting the key and value from the object
              const [type, display] = Object.entries(item)[0];

              return (
                <button
                  key={type}
                  className={`px-4 py-2 text-sm md:text-base ${
                    activeButton === type
                      ? "bg-pink-800 hover:bg-pink-700 text-white rounded-md"
                      : "bg-[#FAF5FF] hover:bg-violet-100 hover:text-pink-800 rounded-md"
                  }`}
                  onClick={() => {
                    setLoading(false);
                    setActiveButton(type);
                    if (type !== "all") setActiveFilter(false);
                  }}
                >
                  {display}
                </button>
              );
            }
          )}
        </div>

        {/* Right Search and Filter Section */}
        {activeButton === "all" && (
          <div className="flex flex-col md:flex-row w-full md:w-1/2 items-center gap-4">
            <label className="flex items-center gap-2 rounded-lg px-3 py-2.5 bg-white border border-pink-600 w-full  max-w-md sm:w-full">
              <IoIosSearch className="w-5 h-5 text-gray-500" />
              <input
                type="text"
                className="w-full bg-transparent outline-none text-sm"
                placeholder="Search by title..."
                name="title"
                value={allQuery.title}
                onChange={handleFilterChange}
              />
            </label>

            <button
              className={`tracking-[0.5px] flex items-center  justify-center sm:self-end xs:self-end gap-2 py-2 w-[140px] hover:tracking-[1px] transition-all duration-150 border border-pink-600  rounded-lg text-sm md:text-base ${
                activeFilter ? "text-[#97266D] bg-[#FAF5FF] font-semibold" : ""
              } hover:bg-[#FAF5FF]`}
              onClick={() => setActiveFilter(!activeFilter)}
            >
              <BsFilter /> FILTERS
            </button>
          </div>
        )}
      </div>

      {/* Filters Section */}
      {activeFilter && (
        <div
          className={`overflow-hidden transition-all duration-500 ease-in-out mt-4`}
          style={{ height: `${contentHeight}px` }}
        >
          <div ref={contentRef} className="flex flex-col gap-4 p-2">
            {/* Filters Form */}
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4 xs:gap-2">
              {[
                {
                  label: "Category",
                  name: "category",
                  options: ["Coding", "DSA", "Assignment", "Scrum"],
                  value: allQuery.category,
                },
                {
                  label: "Lecture Type",
                  name: "lectureMode",
                  options: ["Live", "Video", "Reading"],
                  value: clickedLink === "videos" ? "Video" : "Live",
                  disabled: true,
                },
                {
                  label: "Instructors",
                  name: "instructorName",
                  options: ["Suraj Tiwari", "Prashant Saxena"],
                  value: allQuery.instructorName,
                },
                {
                  label: "Lecture Date",
                  name: "date",
                  type: "date",
                  value: allQuery.date,
                },
              ].map(
                ({
                  label,
                  name,
                  options,
                  type = "select",
                  value,
                  disabled = false,
                }) => (
                  <label key={name} className="form-control w-full">
                    <div className="label mb-2">
                      <span className="label-text text-sm font-medium">
                        {label}
                      </span>
                    </div>
                    {type === "select" ? (
                      <select
                        name={name}
                        value={value}
                        onChange={handleFilterChange}
                        disabled={disabled}
                        className={`rounded-lg px-4 py-2 w-full border text-sm focus:border-pink-600 focus:outline-none ${
                          disabled ? "cursor-not-allowed" : ""
                        }`}
                      >
                        <option value="" disabled>
                          Select {label}
                        </option>
                        {options.map((option) => (
                          <option
                            key={option}
                            value={option}
                            disabled={disabled && option === value}
                          >
                            {option}
                          </option>
                        ))}
                      </select>
                    ) : (
                      <input
                        type={type}
                        name={name}
                        value={value}
                        onChange={handleFilterChange}
                        className="rounded-lg px-4 py-2 w-full border text-sm focus:border-pink-600 focus:outline-none"
                      />
                    )}
                  </label>
                )
              )}
            </div>

            {/* Actions */}
            <div className="flex gap-4 justify-end mt-4 ">
              <button
                className="rounded-lg px-4 py-2 tracking-[0.5px] bg-[#FAF5FF] text-[#97266D] hover:tracking-[1px] trasition-all duration-200 hover:bg-violet-100 text-sm md:text-base"
                onClick={resetFilterBtn}
              >
                RESET FILTER
              </button>

              <button
                className="rounded-lg px-4 py-2 tracking-[0.5px] bg-pink-800 text-white hover:tracking-[1px] trasition-all duration-200 hover:bg-pink-900 text-sm md:text-base"
                onClick={(e) => {
                  e.preventDefault();
                  fetchLectures(activeButton);
                }}
              >
                APPLY
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default FilterBox;
